/* PW Cards — touch layer. The desktop site gets hover tilt, parallax and hover lifts; phones
   can't hover, so this adds the touch equivalents: a hero fan that cycles on its own, rails that tilt as
   you scroll them, cards that settle in as they arrive, a scroll hint on rails, and small
   haptic ticks (Android). Runs only on touch devices; respects reduced motion. */
(function () {
  'use strict';
  var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!coarse) return;
  document.documentElement.classList.add('pw-touch');

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var tick = function (ms) { try { if (navigator.vibrate) navigator.vibrate(ms || 8); } catch (e) {} };

  /* ------------------------------------------------------------ hero fan */
  function initFan() {
    var fan = $('[data-pw-fan]');
    if (!fan) return;
    var stage = fan.closest('.pw-hero__stage') || fan.parentElement;
    var ready = function () { return fan.classList.contains('is-ready') && !$('.pw-fan__card--ghost', fan); };
    if (!ready()) {
      var mo = new MutationObserver(function () { if (ready()) { mo.disconnect(); setup(); } });
      mo.observe(fan, { attributes: true, childList: true, subtree: true });
      return;
    }
    setup();

    function setup() {
      var cards = $$('.pw-fan__card', fan);
      var n = cards.length;
      if (n < 2) return;
      stage.classList.add('is-carousel');
      var active = Math.floor(n / 2);
      var half = Math.floor(n / 2);
      var dots = document.createElement('div');
      dots.className = 'pw-fan-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
      stage.appendChild(dots);
      var prev = cards.map(function (c, i) { return i - active; });

      function place(animate) {
        cards.forEach(function (c, i) {
          var pos = ((i - active) % n + n + half) % n - half;
          var jump = Math.abs(pos - prev[i]) > half;
          if (jump && animate) {
            // Cards that wrap round the ends fade across instead of sweeping through the fan
            c.style.transition = 'none';
            c.style.opacity = '0';
            c.style.setProperty('--spread', pos);
            void c.offsetWidth;
            c.style.transition = '';
            requestAnimationFrame(function () { c.style.opacity = ''; });
          } else {
            c.style.setProperty('--spread', pos);
          }
          c.classList.toggle('is-active', pos === 0);
          prev[i] = pos;
        });
        $$('i', dots).forEach(function (d, i) { d.classList.toggle('is-on', i === active); });
      }
      place(false);

      function go(to) {
        active = (to + n) % n;
        place(true);
      }

      // No swiping: the fan just cycles on its own. Tapping any card opens it.
      var lastUser = 0;
      stage.addEventListener('pointerdown', function () { lastUser = Date.now(); }, { passive: true });

      // Gentle auto-advance while the hero is on screen and nobody is touching it
      if (!reduce) {
        var visible = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(stage);
        }
        setInterval(function () {
          if (!visible || document.hidden || Date.now() - lastUser < 2500) return;
          go(active + 1);
        }, 3400);
      }

      // Android: tilt the fan with the phone (iOS would need a permission prompt, so it's left out)
      if (!reduce && 'DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {
        var base = null, raf = 0;
        window.addEventListener('deviceorientation', function (ev) {
          if (ev.gamma == null || document.hidden || (typeof visible !== 'undefined' && !visible)) return;
          if (!base) base = { b: ev.beta, g: ev.gamma };
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var x = Math.max(-1, Math.min(1, (ev.gamma - base.g) / 25));
            var y = Math.max(-1, Math.min(1, (ev.beta - base.b) / 25));
            fan.style.setProperty('--px', (x * 0.6).toFixed(3));
            fan.style.setProperty('--py', (y * 0.5).toFixed(3));
          });
        }, { passive: true });
      }
    }
  }

  /* ------------------------------------ rails: cards lean as you swipe them */
  function initRails(root) {
    if (reduce) return;
    $$('.pw-rail__track', root).forEach(function (track) {
      if (track.__pwTouch) return;
      track.__pwTouch = true;
      var raf = 0, onScreen = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          onScreen = en[0].isIntersecting;
          if (onScreen && !raf) raf = requestAnimationFrame(update);
        }, { rootMargin: '100px 0px' }).observe(track);
      } else onScreen = true;
      var update = function () {
        raf = 0;
        if (!onScreen) return; // off screen: nothing to lean, and measuring would force a layout
        var tr = track.getBoundingClientRect();
        var mid = tr.left + tr.width / 2;
        // read every position first, then write: interleaving them forced a layout per card
        var tilts = $$('.pw-card__tilt', track);
        var rects = tilts.map(function (t) { return t.getBoundingClientRect(); });
        tilts.forEach(function (t, i) {
          var r = rects[i];
          if (r.right < tr.left - 40 || r.left > tr.right + 40) return;
          var d = (r.left + r.width / 2 - mid) / tr.width; // about -0.6 … 0.6
          t.style.setProperty('--ry', (-d * 16).toFixed(2) + 'deg');
          t.style.setProperty('--rx', (Math.abs(d) * 4).toFixed(2) + 'deg');
        });
      };
      track.addEventListener('scroll', function () {
        track.classList.add('is-swiping');
        if (!raf) raf = requestAnimationFrame(update);
        clearTimeout(track.__pwIdle);
        track.__pwIdle = setTimeout(function () {
          track.classList.remove('is-swiping');
        }, 140);
      }, { passive: true });
      // Cards arrive after the rail loads its data; lean them once they're in
      new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(update); }).observe(track, { childList: true });
      if (!raf) raf = requestAnimationFrame(update);

      // One small nudge the first time a rail comes on screen, so people know it scrolls sideways
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (track.scrollLeft > 4 || track.scrollWidth <= track.clientWidth + 8) return;
            track.animate(
              [{ transform: 'translateX(0)' }, { transform: 'translateX(-28px)' }, { transform: 'translateX(0)' }],
              { duration: 900, easing: 'cubic-bezier(.3,.7,.2,1)', delay: 250 }
            );
          }, 400);
        }, { threshold: 0.6 });
        io.observe(track);
      }
    });
  }

  /* ------------------------------ grids: cards settle in as they scroll up */
  // The observer's first report for a card says whether it was already on screen; those are left
  // alone, the rest get the settle-in. (Reading every card's position up front forced a full layout.)
  var cardIO = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        var shown = 0;
        entries.forEach(function (en) {
          var el = en.target;
          if (!el.__pwSeen) {
            el.__pwSeen = true;
            if (en.isIntersecting) { cardIO.unobserve(el); return; } // already visible: no animation
            el.classList.add('pw-land');
            return;
          }
          if (!en.isIntersecting) return;
          cardIO.unobserve(el);
          el.style.setProperty('--pw-in-delay', (shown++ % 6) * 45 + 'ms');
          el.classList.add('is-landed');
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 })
    : null;
  function initCards(root) {
    if (!cardIO) return;
    $$('.pw-grid .pw-card:not([data-pw-watch]), .pw-catalog .pw-card:not([data-pw-watch])', root).forEach(function (c) {
      c.setAttribute('data-pw-watch', '');
      cardIO.observe(c);
    });
  }

  /* ------------------------------------------------------------ haptics */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pw-wish], .pw-heart')) tick(8);
    else if (e.target.closest('.pw-add, [data-pw-add] [type="submit"], .pw-tab, .pw-chip')) tick(5);
  }, { passive: true });

  /* ------------------------------------------------------------- boot */
  function boot() {
    initFan();
    initRails(document);
    initCards(document);
    // Catalogue "load more" / filters and lazy rails add cards later
    var grids = $$('.pw-catalog, .pw-grid, main');
    if (grids.length) {
      var t = 0;
      new MutationObserver(function (records) {
        var relevant = records.some(function (r) {
          for (var i = 0; i < r.addedNodes.length; i++) {
            var n = r.addedNodes[i];
            if (n.nodeType === 1 && (n.matches('.pw-card, .pw-rail__track') || n.querySelector('.pw-card, .pw-rail__track'))) return true;
          }
          return false;
        });
        if (!relevant) return;
        clearTimeout(t);
        t = setTimeout(function () { initRails(document); initCards(document); }, 60);
      }).observe($('main') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
